const normalise = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, ' ').trim();
export function consultationHistoryForName(rows, name) {
  const matches = (rows || []).filter(row => normalise(row.conseillere) === normalise(name));
  // Never silently merge different employees who share the same name.
  if (matches.length !== 1) return { confirmed: 0, appointments: 0, leads: 0, ambiguous: matches.length > 1 };
  return { confirmed: Number(matches[0].consultationsConfirmees || 0), appointments: Number(matches[0].rendezVousTerminesHistoriques || 0), leads: Number(matches[0].leadsMarquesConsultes || 0), ambiguous: false };
}
